import success from '../assets/success.png';

const Success = () => {
    return (
        <div className="container d-flex justify-content-center align-items-center">
            <div className="row">
                <div className="col-md-6 mx-auto mt-5">
                    <div className="payment">
                        <div className="payment_header">
                            <div className="check"><i className="fa fa-check" aria-hidden="true"></i></div>
                        </div>
                        <div className="content">
                            <h1>Registro Exitoso !</h1>
                            <img src={success} alt=""/>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Success;